import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const clientService = { getAllClients, getClient, createClient, updateClient }

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = { page: filter?.pageNumber, size: filter?.pageSize }
  if (filter?.accountNo) params.account_no = filter.accountNo
  if (filter?.sortBy) params.sort_by = filter.sortBy
  if (filter?.orderBy) params.order_by = filter.orderBy
  if (filter?.clientGroupId) params.client_group_id = filter.clientGroupId
  if (filter?.areaCode) params.area_code = filter.areaCode
  filter?.searchArray?.forEach((w, i) => {
    if (w !== null && w !== '') params[`search_words[${i}]`] = w
  })
  return params
}

export function getAllClients(filter) {
  return apiHelper(API_URL).get('/clients', { params: buildParams(filter) })
}
export function getClient(accountNo) {
  return apiHelper(API_URL).get(`/clients/${accountNo}`)
}
export function createClient(payload) {
  return apiHelper(API_URL).post('/clients', payload)
}
export function updateClient(accountNo, payload) {
  return apiHelper(API_URL).put(`/clients/${accountNo}`, payload)
}
